import { theme } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Popover } from 'antd'
import type { ReactNode } from 'react'
import styled from 'styled-components'

type ContextualPopoverProps = { text: string; children: ReactNode }
const ContextualPopover = ({ text, children }: ContextualPopoverProps) => {
  return (
    <StyledPopover
      color={theme.color.neutral.color3}
      placement="bottomRight"
      showArrow
      arrow={{ pointAtCenter: true }}
      trigger="hover"
      content={<TitleText level={2}>{text}</TitleText>}
    >
      {children}
    </StyledPopover>
  )
}

const StyledPopover = styled(Popover)`
  border-radius: 9px;
`

const TitleText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color11};
`

export default ContextualPopover
